import { createContext } from 'react';

/**
 * Initializes a context for sharing countries between components.
 * More info can be found in https://reactjs.org/docs/context.html
 */
export const CountriesContext = createContext([]);
